import React, { useState, useEffect } from 'react';
import './BrandedLoader.css';

const FlightLoader = () => {
  const logos = [
    '/assets/images/logo.png'
  ];

  // ... rest of the component is the same
  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentLogoIndex(prevIndex => (prevIndex + 1) % logos.length);
    }, 2000);

    return () => clearInterval(intervalId);
  }, [logos.length]);

  return (
    <div className="branded-loader-container">
      <img
        key={currentLogoIndex}
        src={logos[currentLogoIndex]}
        alt="Loading..."
        className="branded-loader-image"
      />
      <p className="branded-loading-text">Loading, Please wait...</p>
    </div>
  );
};
 
export default FlightLoader;